import React, { useState, useEffect, useMemo } from 'react';
import { Card, Grid, CardContent, TextField, List, ListItem, ListItemText, Divider, Button, Dialog } from '@material-ui/core';
import axios from 'axios';
import StrapiMediaPopup from "./StrapiMediaPopup";
import qs from 'qs';
import settings from '../../settings';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	image_list: {
		height: "200px",
		overflow: "auto",
	},
}));

interface StrapiMediaShowProps {
	type?: string,
	image: {url: string, caption: string, name: string, alternativeText: string}, 
}

const StrapiImageShow = (props: StrapiMediaShowProps) => {
	const [open, setOpen] = useState<boolean>(false);
	const elem = useMemo(() => {
		if (props.type && props.type === "video") {
			return <video controls width={200} src={props.image.url}></video>
		} else {
			return <img onClick={() => {
				setOpen(true);
			}} src={props.image.url} height={"100"} alt="" />
		}
	}, [props.type, props.image.url]);

	return <>
		{elem}
		<Dialog open={open} onClose={() => {
			setOpen(false)
		}}>
			<Card>
				<CardContent>
					<p>Name: {props.image.alternativeText !== "" ? props.image.alternativeText : props.image.name}</p>
					<p>Crédit: {props.image.caption}</p>
					{ props.type === "video" ? 
						<video controls src={props.image.url}></video>
						: <img src={props.image.url} alt=""/>
					}
				</CardContent>
			</Card>
		</Dialog>
	</>
}

interface StrapiMediaProps {
	label?: string,
	type?: "video" | "image" | "all",
	value: any[],
	onChange: (newValue: any[]) => void,
	multiple?: boolean,
};

const StrapiMedia = (props: StrapiMediaProps) => {
	const [search, setSearch] = useState<string>("");
	const [images, setImages] = useState<any[]>([]);
	const [open, setOpen] = useState<boolean>(false);
	const classes = useStyles();

	useEffect(() => {
		const params = {
			_where: {
				mime_contains: props.type ? props.type : "",  
				_or: [
					{alternativeText_contains: search},
					{name_contains: search}
				],
			},
			caption_ncontains: "Reuters",
			_limit: 10,
			id_nin: props.value.map((e) => e.id)
		}
		axios.get(`${settings.strapiUrl}upload/files?${qs.stringify(params)}`).then((r) => {
			setImages(r.data);
		}).catch((e) => {
			console.log("error", e);
		});
	}, [search, props.value]);

	const loadMore = () => {
		const params = {
			_where: {
				mime_contains: props.type ? props.type : "",  
				_or: [{alternativeText_contains: search},
					{name_contains: search}
				],
			},
			caption_ncontains: "Reuters",
			_start: images.length,
			_limit: 10,
			id_nin: props.value.map((e) => e.id)
		}
		axios.get(`${settings.strapiUrl}upload/files?${qs.stringify(params)}`).then((r) => {
			setImages([...images, ...r.data]);
		}).catch((e) => {
			console.log("error", e);
		});
	}

	const onScroll = (e: any) => {
		if (e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight) {
			loadMore();
		}
	}

	return <>
		<Card>
			<CardContent>
				{props.label && <p>{props.label}</p>}
				<List>
					{props.value && props.value.map((image) =>
						<ListItem key={image.id}>
							<ListItemText>{image.alternativeText ? image.alternativeText : image.name}</ListItemText>
							<StrapiImageShow image={image} type={props.type}/>
							<Button onClick={() => {
								let temp = props.value;
								temp = temp.filter((e) => e.id !== image.id)
								props.onChange(temp);
							}}>Suppimer</Button>
						</ListItem>
					)}
				</List>
				<Grid
					container
					direction="column"
					justify="flex-start"
				>
					<TextField
						label={"Recherche " + props.type}
						onChange={(e) => {
							setSearch(e.target.value);
						}}
					/>
				</Grid>
				<Divider />
				<div className={classes.image_list} onScroll={onScroll}>
					{images.map((image) => (
						<ListItem key={image.id}>
							<ListItemText>{image.alternativeText ? image.alternativeText : image.name}</ListItemText>
							<StrapiImageShow type={props.type} image={image}/>
							<Button onClick={() => {
								if (props.multiple) {
									props.onChange([...props.value, image]);
								} else {
									props.onChange([image]);
								}
							}}>{props.multiple ? "Ajouter" : "Choisir"}</Button>
						</ListItem>
					))}
				</div>
			</CardContent>
			<Button onClick={() => {
				setOpen(true);
			}}>Choisir une {props.type}</Button>
			<StrapiMediaPopup type={props.type} open={open} onClose={(n?: any) => {
				setOpen(false);
				if (n) {
					if (props.multiple) {
						props.onChange([...images, n])
					} else {
						props.onChange([n])
					}
				}

			}} />
		</Card>
	</>
};

export default StrapiMedia;